import { renderIcon } from '@ixicare/ui';
import { X } from 'lucide-react';
import * as React from 'react';

export interface RemovableChipProps {
  /** Called when the remove (×) button is clicked. */
  onRemove: () => void;
  /** Background color of the chip. */
  color?: string;
  /** Accessible title/tooltip for the remove button. */
  removeTitle?: string;
  /** Chip label. */
  children: React.ReactNode;
}

const DEFAULT_COLOR = '#f3e5f5';

// Generic pill with a label and a remove button.
// TODO: Move into @ixicare/ui.
const RemovableChip: React.FC<RemovableChipProps> = ({ onRemove, color = DEFAULT_COLOR, removeTitle, children }) => (
  <div
    style={{
      padding: '4px 12px',
      background: color,
      borderRadius: '16px',
      fontSize: '14px',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    }}
  >
    <span>{children}</span>
    <button
      onClick={onRemove}
      title={removeTitle}
      style={{
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '0',
        display: 'flex',
        alignItems: 'center',
        fontSize: '16px',
      }}
    >
      {renderIcon('cross', X)}
    </button>
  </div>
);

export default RemovableChip;
